import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './HomeApp.css';

export default function HomeApp() {
    const [menuData, setMenuData] = useState([])
    const [newsList, setNewsList] = useState([])
    const [selectedKey, setSelectedKey] = useState(null);

    useEffect(() => {
        let source = axios.CancelToken.source();

        async function fetchData() {
            try {
                let res;
                const cachedData = localStorage.getItem("categories");
                // 如果有缓存数据，直接使用
                if (cachedData) {
                    res = JSON.parse(cachedData);
                } else {
                    // 从远程获取数据
                    res = await axios.get("https://api.360ep.cn/api/category/?type=sep", {
                        cancelToken: source.token,
                    });

                    // 将获取到的数据存储到localStorage中
                    localStorage.setItem("categories", JSON.stringify(res.data));
                    res = res.data;
                }

                let menuItems = [];
                res.data.forEach(item => {
                    menuItems.push(
                        {
                            label: item.catname,
                            key: item.catid
                        }
                    );
                });


                setMenuData(menuItems);
                chooseCat(menuItems[0]);
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log("Request canceled", error.message);
                } else {
                    console.log("Error", error.message);
                }
            }
        }

        fetchData();

        return () => {
            source.cancel("Request canceled by user");
        };
    }, []);

    function chooseCat(catid) {
        setSelectedKey(catid)
        axios.get("https://api.360ep.cn/api/news?pagesize=5").then(
            res => {
                let news = []
                res.data.data.forEach(item => {
                    news.push(
                        {
                            Itemid: item.Itemid,
                            title: item.Title,
                            thumb: item.Thumb,
                        }
                    );
                });
                setNewsList(news)
            }
        )
    }

    return (
        <div className="home-app">
            <div className='app-line'>
                <div className="app-title">
                    应用专业分析与介绍
                </div>
                <div className='app-cat'>
                    {
                        menuData.map((item, index) => {
                            return (
                                <div className='cat-item' key={index}>
                                    <span onClick={() => chooseCat(item.key)} style={{
                                        fontWeight: selectedKey === item.key ? 'bold' : 'normal',
                                        color: selectedKey === item.key ? 'red' : '#797979',
                                    }}>{item.label}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className='app-list'>
                {
                    newsList.map((item, index) => {

                        let newsUrl = "https://info.360ep.cn/news/show.php?itemid=" + item.Itemid;

                        return (
                            <div className='app-item' key={index}>
                                <a href={newsUrl} target='_blank' rel="noopener noreferrer"><img src={item.thumb} alt={item.title} /></a>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
